import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";

import  ZilrettaLogo  from "src/assets/images/zilrettaLogo.png";
import  IoveraLogo  from "src/assets/images/iovera-logo.svg";
import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";
// import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";

import { AuthContext } from "../../context/authContext";
import { ToastContext } from "../../context/toastContext";

// import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import { LoginSchema } from "../../validation/login";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { UserType } from "src/types/users";
import { redirectPath, USER_TYPES } from "src/constants";
import { LoginFormType, LoginAPIResponseType } from "./types";




const HubLogin: FC = (): JSX.Element => {
  const [isPasswordVisible, setPasswordVisibility] = useState<boolean>(false);

  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(LoginSchema),
  });
  const { userData: sessionSavedUser, createSession, restoreSession } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const isSingleSignOn = localStorage.getItem("fromSingleSignOn");

  // const routeToRelevantPaths = (userData: UserType) => {
  //   if (userData.ref_type === 'Manufacturer' || userData.ref_type === 'fam_rm') {
  //     navigate("/statistics");
  //   } else if (userData.ref_type === 'regional_manager') {
  //     navigate("/regions");
  //   } else if (userData.ref_type === 'district_manager') {
  //     navigate("/districts");
  //   } else if (userData.ref_type === 'fam_am') {
  //     navigate("/fam_regions");
  //   // } else if (userData.ref_type === 'fam_rm') {
  //   //   navigate("/fam_districts");
  //   } else if (userData.ref_type === 'rep') {
  //     navigate("/territories");
  //   } else if (USER_TYPES.HCP.includes(userData.ref_type)) {
  //     navigate("/cases");
  //   }
  // }

  const reRouteRelevantUser = (userData: UserType) => {
    localStorage.removeItem('newCase')
    if (isSingleSignOn) {
      navigate(redirectPath(userData))
    } else {
      if (!userData.is_password_changed) {

        navigate("/users/createuser");
      } else {

        if (USER_TYPES.MANUFACTURER.includes(userData.ref_type))
          navigate(redirectPath(userData))
        else
          navigate("/cases")
      }
    }
  };

  const { data: userData, loading, mutate, error, removeErrorAndData } = useFetch<LoginAPIResponseType>(APIEndpoints.USER_SIGNIN);

  useEffect(() => {
    if (userData && userData.status.code === 200) {
      const { status, token ,} = userData;
      createSession(
        {
          ...status.data.user,
          practice_created_date: status.data.address ? status.data.address.date : "",
          practice_name: status.data.address ? status.data.address.name : "",
          address: status.data.address ? status.data.address.ref_address : "",
          reset_demo_cases: status.data.navbar.reset_demo_cases,
          stats_view: status.data.navbar.stats_view,
          demo_user_view: status.data.navbar.demo_user_view,
          eob_button: status.data.navbar.eob_button,
          is_jnj: status.data.is_jnj || false,
          is_iovera_user:status.data.navbar.is_iovera_user || false,
          is_zilretta_user:status.data.navbar.is_zilretta_user || false

        },
        status.data.sub_header,
        token,
        status.data.iovera_practice,
      );
      //:- Session Data updating while logging in
      // const sessionData = localStorage.getItem("sessionData")
      // if (sessionData) {
      //   const updatedSession: any = JSON.parse(sessionData);
      //   if (!updatedSession.user_id || !updatedSession.user_name) {
      //     updatedSession.user_id = userData.status.data.user.id
      //     updatedSession.user_name = userData.status.data.user.email
      //   }
      //   localStorage.setItem("sessionData", JSON.stringify(updatedSession))
      // }
      //:- End Session data logic
      showToast([status.message], ToastTypes.INFO);

      reRouteRelevantUser(status.data.user);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const submitForm = async (values: LoginFormType) => {
    if ((error && error.length > 0) || userData) removeErrorAndData();
    const isSessionExists = restoreSession();

    if (!isSessionExists) {
      mutate({ user: values });
    } else {
      showToast([`There is already an active user session`], ToastTypes.INFO);
      if (sessionSavedUser) reRouteRelevantUser(sessionSavedUser);
    }
  };

    return (
        <>
            <div className="login-sec pt-3 d-flex flex-fill flex-column justify-content-between overflow-auto">
                <div className="container d-flex flex-fill">
                    <div className="row flex-fill mt-lg-5">
                        <div className="col-lg-8 col-md-6 col-12">
                            <div className="products-logos gap-3 gap-lg-5 mb-3 mb-lg-0">
                                <img className="zilretta-logo" src={ZilrettaLogo} alt="Zilretta Logo"/>
                                <img className="iovera-logo" src={IoveraLogo} alt="Iovera Logo"/>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <form className="login-box bg-white rounded-3 p-4 shadow-lg" onSubmit={handleSubmit(submitForm)}>
                                <h5 className="mb-0 fw-normal">Welcome to</h5>
                                <h3 className="mb-3 fw-medium">FlexForward</h3>
                                <div>
                                    <Controller
                                        name="email"
                                        control={control}
                                        defaultValue=""
                                        render={({field, fieldState: {error}}) => (
                                            <div className={"mb-3"}>
                                                <label htmlFor="email" className="form-label justify-content-start mb-2">Email *</label>
                                                <HubInputField
                                                    inputId="email"
                                                    inputPlaceholder="Email"
                                                    isRowBased={false}
                                                    isRequired={true}
                                                    field={field}
                                                    error={error}
                                                    inputType="email"
                                                />
                                            </div>
                                        )}
                                    />
                                    <Controller
                                        name="password"
                                        control={control}
                                        defaultValue=""
                                        render={({field, fieldState: {error}}) => (
                                            <div className={"mb-3"}>
                                                <label htmlFor="password" className="form-label justify-content-start mb-2">Password *</label>
                                                <div className="input-group mb-3">
                                                    <input type={isPasswordVisible ? "text" : "password"}
                                                           placeholder="Password" className="form-control" {...field}
                                                    />
                                                    <button type="button" className="btn btn-outline-primary"
                                                            onClick={() => setPasswordVisibility((isPasswordVisible) => !isPasswordVisible)}
                                                    >
                                                        {isPasswordVisible ? (
                                                            <i className="bi bi-eye-fill"></i>
                                                        ) : (
                                                            <i className="bi bi-eye-slash"></i>
                                                        )}
                                                    </button>
                                                </div>
                                                {error && (<p className="mb-0 text-danger">{error.message}</p>)}
                                            </div>
                                        )}
                                    />
                                </div>
                                <div>
                                    <div className="d-flex justify-content-between align-items-center">
                                        <button disabled={loading} className="btn btn-primary" type="submit">
                                            {loading && <i className="spinner-border" style={{
                                                width: "14px",
                                                height: "14px",
                                                borderWidth: "2px"
                                            }}></i>}
                                            {' '}Log in
                                        </button>
                                        <p className="m-0">
                                            <Link to="/users/forgotpassword">Forgot your password?</Link>
                                        </p>
                                    </div>
                                    <p className="small mt-3 mb-0 text-center">
                                        By clicking Log in, you agree to our &nbsp;
                                        <a href="https://www.pacira.com/terms-of-use/" target="_blank" rel="noreferrer">
                                            Terms of Use
                                        </a>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <FooterText footerType="black"/>
            </div>
        </>
    );
};

export default HubLogin;
